import React from "react";
import paymentQR from "../images/payment/paymentQR.jpg";

const Payments = () => {
  return (
    <>
    <h3 className="mt-5">Make the payment of ₹3000 one-time registration fee—valid for one full
      year.</h3>
      <h5>Send the Screenshot of the payment to  <strong>admin@cnnmandram.com (or) whatsapp 9445943929</strong> </h5>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
        marginBottom: "5%",
        marginTop: "5%",
      }}
    >
      
      <img
        src={paymentQR}
        style={{
          width: "300px",
          justifyItems: "center",
          alignItems: "center",
        }}
      />
    </div>
    </>
  );
};

export default Payments;
